import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import resources from './translations.json'

const supportedLngs = ['en', 'ar']

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: 'en',
    keySeparator: false, // we don't use keys in form of messages.welcome
    supportedLngs,
    interploation: {
      escapeValue: false // react already safes from xss
    }
  })

export default i18n
